import { ReactComponent as CopyIconGray } from "assets/icons/CopyIconGray.svg";
import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

const CopyButton = ({ value,styles = {}, copyTextStyle = {} }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);



  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <>

      <div
        className={`copy-value__field`}
        style={styles}
        onClick={handleCopy}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CopyToClipboard text={value}>
          <CopyIconGray />
        </CopyToClipboard>
      </div>

      {(isHovered || isCopied) && (
        <div className="copy-value__hint" style={copyTextStyle}>
          {isCopied ? "Copied" : "Copy"}
        </div>
      )}
    </>
  )
}

export default CopyButton